import React, { useId } from 'react';

import { RECEIPT_NOTICE_HEADING } from '../constants/receiptTexts';

import './ReceiptNotice.css';

interface Props {
  /** 見出しの下に表示する本文行 */
  lines: readonly string[];
}

/**
 * 「領収書について」案内ブロック。
 *
 * 領収書発行仕様変更（課題表 381）で、支払方法選択/変更画面と
 * 請求書払い・NP後払いの確認画面に同じ見た目で表示する。
 * 見出しは他画面のセクション見出し（h3.section-title）と同じレベルに揃える。
 */
const ReceiptNotice: React.FC<Props> = ({ lines }) => {
  const headingId = useId();

  return (
    <section className="receipt-notice" aria-labelledby={headingId}>
      <h3 id={headingId} className="receipt-notice-heading">
        {RECEIPT_NOTICE_HEADING}
      </h3>
      {lines.map((line) => (
        <p key={line} className="receipt-notice-line">
          {line}
        </p>
      ))}
    </section>
  );
};

export default ReceiptNotice;
